import { useContext, useEffect } from 'react';

import { Layout } from '@/components/Layout/Layout';
import { Main } from '@/components/Main/Main';
import { Payment } from '@/components/Payment/Payment';
// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';

const PaymentPage = () => {
	const [, dispatch] = useContext(Context);

	useEffect(() => {
		void (async () => {
			const { setTitle } = await import('@/lib/util');
			setTitle('Bezahlseite');
		})();

		dispatch({
			type: ActionTypes.setCurrentPage,
			payload: {
				key: 'currentPage',
				value: 'paymentPage'
			}
		});

		dispatch({
			type: ActionTypes.showProductOnRight,
			payload: true
		});
	}, [dispatch]);

	return (
		<Layout className="layout-split">
			<Main>
				<Payment />
			</Main>
		</Layout>
	);
};

export default PaymentPage;
